import { useResolve } from '@visiba/instantiation';
import { AuthService, User } from './auth.service';
import { useLayoutEffect } from 'react';
import { useMisbehavedForceUpdate } from '@visiba/react-std';

export function useUser(): User | null {
	const authService = useResolve(AuthService);
	const update = useMisbehavedForceUpdate();

	useLayoutEffect(() => {
		const cb = (_: User) => {
			update();
		};
		const disposers = [authService.on('onAuthenticationTermination', cb), authService.on('onSuccessfulAuthentication', cb)];

		return () => {
			disposers.forEach((d) => d());
		};
	}, [authService, update]);

	return authService.getUser();
}
